
import { Box, Flex, Text } from '@chakra-ui/react';
import { faArrowUpRightFromSquare, faFile } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Accordion, Badge, ButtonText } from '@morressier/alembic';
import { IAdjudicatorFeedback } from '@publishing-engine/domain/models';
import { openFile } from 'src/utils/file';

const renderItem = (
  review: IAdjudicatorFeedback,
) => {
  const { attachments, comment } = review;

  return (
    <Flex flexDirection="column" gap={6} padding={2}>
      <Box><Badge>Adjudication Report</Badge></Box>
      <Box>
        <Text textStyle="headingItem">Feedback for Authors</Text>
        <Text textStyle="textBody">{comment}</Text>
      </Box>

      {!!attachments?.length && (
        <Box marginTop={2}>
          <Text textStyle="headingItem">Adjudicator Files</Text>
          <Flex flexDirection="column" marginTop={2} gap={2}>
            {(attachments ?? []).map(attachment => (
              <Flex
                justifyContent="space-between"
                key={attachment.referenceName}
              >
                <Flex gap={2} alignItems="center">
                  <FontAwesomeIcon icon={faFile} />
                  <Text textStyle="textBody">{attachment.referenceName}</Text>
                  <ButtonText onClick={() => openFile(attachment.url)} iconLeft={<FontAwesomeIcon icon={faArrowUpRightFromSquare} />}>
                    View
                  </ButtonText>
                </Flex>
              </Flex>
            ))}
          </Flex>
        </Box>
      )}
    </Flex>
  );
};

const AdjudicatorReviewSummary = ({
  adjudicatorReview
}: {
  adjudicatorReview: IAdjudicatorFeedback[]
}) => {
  return (
    <Accordion
      accordionItemProps={{
        marginBottom: 0,
        borderTop: '1px',
        borderColor: 'neutralPrimaryBorder',
      }}
      items={adjudicatorReview.map((adjudicator, index: number) => ({
        title: `Adjudicator ${index + 1} Feedback`,
        content: renderItem(adjudicator)
      }))}
    />
  );
};

export default AdjudicatorReviewSummary
